import { type CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';
import {
  useBrandTokens,
  useSidebarState,
  useResizableSidebar,
  SIDEBAR_COLLAPSED_WIDTH,
  TopBar,
} from './shared';

export function HomeShellLayout() {
  const brandTokens = useBrandTokens();
  const { collapsed } = useSidebarState('powercareai:patient-sidebar-collapsed');
  const { width: sbWidth } = useResizableSidebar({
    storageKey: 'powercareai:patient-sidebar-width',
    defaultWidth: 360,
    collapsed,
  });

  return (
    <div
      className="pc-desk pc-viewport-fill"
      style={
        {
          ...brandTokens,
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'var(--topbar-height) 1fr',

          fontFamily: 'var(--font-family)',
        } as CSSProperties
      }
    >
      <TopBar sidebarWidth={collapsed ? SIDEBAR_COLLAPSED_WIDTH : sbWidth} />

      {/* Full-width content area */}
      <div
        style={{
          padding: 'var(--content-inset)',
          overflow: 'auto',
        }}
      >
        <div
          style={{
            background: 'var(--bg-surface)',
            borderRadius: 'var(--main-card-radius)',
            boxShadow: 'var(--shadow-paper)',
            height: '100%',
            overflow: 'auto',
            padding: 'var(--sp-6)',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
